import { render, staticRenderFns } from "./broker-phone.vue?vue&type=template&id=27243185"
import script from "./broker-phone.vue?vue&type=script&lang=js"
export * from "./broker-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports